import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Multitenant } from '../../../services/multitenant.provider';
import { StorageProvider } from '../../../services/storage.provider';
import { Search } from '../../../models/search.model';
import { ConfigService } from '../../../services/config.service';
import { AuthProvider } from '../../../services/auth.provider';

@Component({
  selector: 'app-custom-header',
  templateUrl: 'header.html',
  styleUrls: ['header.scss']
})
export class HeaderComponent implements OnInit {
  @Output() notify: EventEmitter<string> = new EventEmitter<string>();
  public logged: boolean;
  public unlogged: boolean;
  public profileName: string;
  public themeClass: string;
  public search = false;
  public model = new Search();
  public profileAvatar: any;

  constructor(
    private router: Router,
    private multiTenant: Multitenant,
    private storage: StorageProvider,
    private config: ConfigService,
    public authService: AuthProvider
  ) { }

  public goToLogin() {
    if (
      this.themeClass !== 'playbacpresse' &&
      this.themeClass !== 'mwjp' &&
      this.themeClass !== 'mwde' &&
      this.themeClass !== 'clfy' &&
      this.themeClass !== 'mljp' &&
      this.themeClass !== 'mlde'
    ) {
      window.open('https://m-digital.playbacpresse.fr/connexion');
    } else {
      this.router.navigate(['connexion'], { queryParams: { page: 'login'} });
    }
  }

  public goToProfiles() {
    this.router.navigate(['profiles']);
  }

  ngOnInit() {
    this.themeClass = this.multiTenant.getDomainClass();
  }

  public isAuthenticated() {
    const cucu = this.storage.getStorage('access_token');
    const profile = this.storage.getStorage('logged_profile_id');
    if (cucu && profile) {
      this.profileName = this.storage.getStorage('logged_profile_name');
      if (this.storage.getStorage('logged_profile_avatar')) {
        this.profileAvatar = this.storage.getStorage('logged_profile_avatar');
      }
      return true;
    } else {
      return false;
    }
  }

  public isAbboner() {
    const cucu = this.storage.getStorage('access_token');
    const profile = this.storage.getStorage('logged_profile_id');
    const url = window.location.href;
    const isOffers = url.search('offres');

    if (cucu && !profile) {
      return true;
    }

    if (cucu && profile) {
      return true;
    }

    if (!cucu && !profile && isOffers === -1) {
      return false;
    } else {
      return true;
    }
  }

  public getProfileName() {
    return this.storage.getStorage('logged_profile_name');
  }

  public getProfileNickName() {
    return this.storage.getStorage('logged_profile_nickname');
  }

  public getActivePage() {
    if (this.storage.getStorage('activePage')) {
      return this.storage.getStorage('activePage');
    }
  }

  public openSearch() {
    this.search = true;
    this.storage.setStorage('search', 'open');
  }

  public doSearch(searchTerm) {
    this.notify.emit(searchTerm);
    this.search = false;
  }

  public goToBoutique() {
    if (this.themeClass === 'lepq') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-le-petit-quotidien',
        '_blank'
      );
    } else if (this.themeClass === 'mquo') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-mon-quotidien',
        '_blank'
      );
    } else if (this.themeClass === 'actu') {
      window.open('https://www.playbacpresse.fr/abonnements-l-actu', '_blank');
    } else if (this.themeClass === 'aeco') {
      window.open('https://www.playbacpresse.fr/abonnements-l-eco', '_blank');
    } else if (this.themeClass === 'mquovideo') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-mon-quotidien-video'
      );
    } else if (this.themeClass === 'actuvideo') {
      window.open('https://www.playbacpresse.fr/abonnements-l-actu-video');
    } else if (this.themeClass === 'week') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-my-weekly',
        '_blank'
      );
    } else if (this.themeClass === 'mwne') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-my-weekly-news',
        '_blank'
      );
    } else if (this.themeClass === 'sema') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-mi-semanal',
        '_blank'
      );
    } else if (this.themeClass === 'woch') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-meine-woche',
        '_blank'
      );
    } else if (this.themeClass === 'mlwk') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-my-little-weekly',
        '_blank'
      );
    } else if (this.themeClass === 'mlne') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-my-little-weekly-news',
        '_blank'
      );
    } else if (this.themeClass === 'mwjp') {
      window.open(
        'https://www.playbacpresse.fr/my-little-weekly-my-weekly-japonais',
        '_blank'
      );
    } else if (this.themeClass === 'mwde') {
      window.open(
        'https://go.playbacpresse.fr/myweekly-german_2019.html',
        '_blank'
      );
    } else if (this.themeClass === 'mljp') {
      window.open(
        'https://www.playbacpresse.fr/my-little-weekly-my-weekly-japonais',
        '_blank'
      );
    } else if (this.themeClass === 'mlde') {
      window.open(
        'https://go.playbacpresse.fr/mylittleweekly-german_2019.html',
        '_blank'
      );
    } else {
      window.open('https://www.playbacpresse.fr', '_blank');
    }
  }

  public goHome() {
    this.router.navigate(['']);
  }

  public getDefaultAvatar(): string {
    const avatar = this.config.getDefaultAvatar();
    return avatar[this.storage.getStorage('logged_profile_type')];
  }

  public goToLoginPage() {
    this.router.navigate(['connexion'], { queryParams: { page: 'login'} });
  }

  // public goToJOLandingPage() {
  //   window.open('https://www.playbacpresse.fr/jeux-olympiques-2024', '_blank');
  // }
}
